import { Dropdown, MenuProps } from "antd";
import LogoutIcon from "components/svg-icons/logout-icon";
import { UserAvatar, UserAvatarWithDetails } from "components/user-avatar";
import { useState } from "react";
import { useHistory } from "react-router";
import { clearAuthCredentials, getUser } from "services/auth";

function AdminAccountMenu() {
  const history = useHistory();
  const [currentUser]: [any, any] = useState(getUser());

  const logout = () => {
    try {
      clearAuthCredentials();
      history.push("/");
    } catch (ex) {
      console.error(ex);
    }
  };

  const menuItems: MenuProps["items"] = [
    {
      label: (
        <UserAvatarWithDetails
          showAvatar={false}
          dataTestId="admin-account-menu-profile-avatar"
          fullName={`${currentUser["first-name"]} ${currentUser["last-name"]}`}
          email={currentUser.email}
        />
      ),
      key: "profile",
      // antd v6 nests its dropdown rules (`.ant-dropdown .ant-dropdown-menu
      // .ant-dropdown-menu-item`), out-specifying plain Tailwind utilities that
      // won on source order under v4 — hence the `!` modifiers here and below.
      className: "!px-2"
    },
    {
      label: (
        <div
          onClick={() => logout()}
          className="flex w-full h-6 items-center justify-between bg-ciq-gray-200 px-4 cursor-pointer"
          data-testid="admin-account-menu-button"
          role="button"
          tabIndex={0}
          onKeyDown={() => {}}
        >
          <div className="flex h-full items-center font-semibold text-xs text-ciq-gray-950">
            Logout
          </div>
          <LogoutIcon />
        </div>
      ),
      key: "sign-out",
      className: "!p-0"
    }
  ];
  return (
    <Dropdown
      arrow
      placement="bottomRight"
      // `overflow-hidden` clips the flush Logout bar to the menu's v6 corner
      // radius (v4's radius was 2px, so the square band went unnoticed).
      menu={{ items: menuItems, className: "!p-0 space-y-1 overflow-hidden" }}
      trigger={["click"]}
      data-testid="index-dropdown"
    >
      <div
        data-cy="account"
        className="accMenuContainer cursor-pointer"
        data-testid="admin-account-menu-dropdown"
      >
        <UserAvatar
          url=""
          isRect={false}
          dataTestId="admin-account-menu-avatar"
          fullName={`${currentUser["first-name"]} ${currentUser["last-name"]}`}
        />
      </div>
    </Dropdown>
  );
}
export default AdminAccountMenu;
